export default "__VITE_ASSET__693fe811__"